'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var loginActions = ['SET_ACCESS_TOKEN', 'LOGOUT', 'LOGIN_WITH_PASSWORD', 'LOGIN_WITH_FACEBOOK', 'HARD_LOGIN_WITH_FACEBOOK', 'LOGOUT_FROM_FACEBOOK', 'FACEBOOK_LOGOUT_SUCCESS', 'FACEBOOK_LOGOUT_FAILURE', 'INIT_GOOGLE_LOGIN', 'LOGIN_WITH_GOOGLE', 'LOGIN_WITH_WIX', 'LOGIN_REQUEST', 'LOGIN_SUCCESS', 'LOGIN_FAILURE', 'HARD_LOGIN_SUCCESS', 'HARD_LOGIN_FAILURE', 'SET_FACEBOOK_AVAILABILITY', 'SET_USING_FORCE_ACCESS_TOKEN', 'SET_FAST_CHECKOUT_ENABLED'];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(loginActions);
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(loginActions);